import React from 'react';
import styled from 'styled-components/macro';
import { MomsChange, Money } from '../../../../../containers/commerce';
import { sanitizeMeasurement } from '../../../../../lib/helpers';
import { sanitizePrice } from '../../../../../lib/price';
import { Col } from '../../../../grid';
import { Paragraph } from '../../../../typography';

const PriceStyled = styled(Money)`
  font-size: 24px;
  font-weight: bold;
`;

const RenderFadoelPrice = ({
  price,
  liter,
  productTypeFadoel,
}) => {
  if (productTypeFadoel) {
    return (
      <Col xs={12} marginTop="20px">
        <Paragraph>
          <Money money={sanitizePrice(price) / sanitizeMeasurement(liter)} /> / ltr.<br />
          <PriceStyled money={sanitizePrice(price)} /> <MomsChange /><br />
          {sanitizeMeasurement(liter)} liter
        </Paragraph>
      </Col>
    );
  }
  return null;
};

// Export
export default RenderFadoelPrice;
